import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
    selector: 'app-dash-tooltip',
    templateUrl: './dash-comment-tooltip.component.html',
    styleUrls: ['./dash-comment-tooltip.component.scss'],
    standalone: false // NOSONAR
})
export class DashCommentTooltip implements ITooltipAngularComp {
  output: string;

  agInit(params: ITooltipParams): void {
    this.output = params.value;
  }
}
